import { TextField, styled } from '@mui/material';

export const NewMainWidgetTextField = styled(TextField)(
  ({ theme }) => ({
    height: '100%',
    '& .MuiInputLabel-root': {
      color: theme.palette.text.secondary,
      fontSize: theme.spacing(2),
        textTransform: 'uppercase',
        transform: 'translate(9px, 16px) scale(0.625)',
      '&.Mui-focused': {
        color: theme.palette.text.secondary,
      },
      '&.Mui-error': {
        color: theme.palette.error.main,
      },
    },
    '& .MuiFilledInput-root': {
      backgroundColor: 'transparent',
      borderBottom: 0,
      borderRadius: 0,
      padding:0,
      paddingRight: '0 !important',
      paddingTop: '0 !important',
      paddingLeft: '0 !important',
      lineHeight: 'unset',
      '&:before, :after': {
        borderColor: 'transparent',
      },
      '&:hover': {
        '&::before, ::after': {
          borderColor: 'transparent !important',
        },
      },
    
      '&.Mui-error': {
        '&:before, :after': {
          borderColor: theme.palette.error.main,
        },
        '&:hover': {
          '&::before, ::after': {
            borderColor: theme.palette.error.main,
          },
        },
      },
      '& .MuiInputBase-input.MuiFilledInput-input': {
        padding: theme.spacing(3.6 , 3, 1.75, 7),
        color: theme.palette.common.white,
        fontSize: theme.spacing(2),
        '&::placeholder': {
          opacity: 1,
          color: theme.palette.common.white,
          fontSize: theme.spacing(2),
        },
       
      },
    },
  }),
);